export default __webpack_public_path__ + "static/media/lab4.ba3056eb.jpg";